export default "__VITE_ASSET__f090ffc1__"